import * as consentActions from '../actions/consent.actions';
import * as disableActions from '../actions/disable-consent.actions';
import { Consent } from '../model/consent.model';

type Actions = consentActions.Actions | disableActions.Actions;

/**
 * Consent reducer - manages consent.
 */
export function consent(state: Consent = null, action: Actions): Consent {
    switch (action.type) {
        case consentActions.LOAD_SUCCESS:
            return action.payload;
        case disableActions.DISABLE_CONSENT_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/reducers/consent.reducer.ts